import { render, staticRenderFns } from "./m-section-seo.vue?vue&type=template&id=9a597668&scoped=true&"
import script from "./m-section-seo.vue?vue&type=script&lang=js&"
export * from "./m-section-seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a597668",
  null
  
)

export default component.exports